// extracted by mini-css-extract-plugin
export default {"select-dropdown":"SelectDropdown_select-dropdown__peOwp","ant-select-multiple":"SelectDropdown_ant-select-multiple__wsYty"};